// eslint-disable-next-line @townsquare/rules/no-define-messages -- Legacy defineMessages usage; migrate under TC-48428
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	errorFlagTitle: {
		id: 'townsquare.invite-user-modal.error-flag.title',
		defaultMessage: 'Something went wrong',
		description: 'Title of a message, shown when adding a user to the project fails',
	},
	errorFlagDescriptionAdmin: {
		id: 'townsquare.invite-user-modal.error-flag.description-admin',
		defaultMessage: 'Please try again.',
		description: 'The default error message when an unexpected error occurs, shown to site admins',
	},
	errorFlagDescription: {
		id: 'townsquare.invite-user-modal.error-flag.description',
		defaultMessage: 'Please try again or contact your administrator for help.',
		description: 'The default error message when an unexpected error occurs',
	},
	allRequestAccessAndInviteFailedFlagTitle: {
		id: 'townsquare.invite-user-modal.all-request-access-and-invite-failed-flag.title',
		defaultMessage: 'Something went wrong',
		description:
			'The title of a notification shown to users indicating that all invites and access requests failed to be sent',
	},
	allRequestAccessAndInviteFailedFlagDescription: {
		id: 'townsquare.invite-user-modal.all-request-access-and-invite-failed-flag.description',
		defaultMessage:
			"We couldn't send any access requests or invitations. {isSiteAdmin, select, true{} other{Contact your admin for help.}}",
		description:
			'The content of a notification shown to users indicating that all invites and access requests failed to be sent',
	},
	requestAccessFailureFlagTitle: {
		id: 'townsquare.invite-user-modal.request-access-failure-flag.title',
		defaultMessage: 'Something went wrong',
		description: 'The title of a notification shown to users indicating a request for access failed',
	},
	requestAccessFailureFlagOneRequestFailed: {
		id: 'townsquare.invite-user-modal.request-access-failure-flag.one-request-access-failed',
		defaultMessage: "We couldn't request access for {email}. Contact your admin for help.",
		description: 'The content of a notification shown to users indicating one request for access was not sent',
	},
	requestAccessFailureFlagMultiRequestFailed: {
		id: 'townsquare.invite-user-modal.request-access-failure-flag.multi-request-access-failed',
		defaultMessage:
			"We couldn't complete your access {count, plural, one {request} other {requests}}. Contact your admin for help.",
		description:
			'The content of a notification shown to users indicating more than one request for access was not sent',
	},
	inviteSuccessFlagTitle: {
		id: 'townsquare.invite-user-modal.invite-success-flag.title',
		defaultMessage: '{invitedCount, plural, one {Invite} other {Invites}} sent',
		description: 'The title of a notification shown to users indicating an invite has been successfully sent',
	},
	inviteSuccessFlagOneInviteSent: {
		id: 'townsquare.invite-user-modal.invite-success-flag.one-invite-sent',
		defaultMessage:
			"You've added {email} to your space. You'll see them on the board once they've been assigned a work item.",
		description: 'The content of a notification shown to users indicating an invite has been sent to a single user',
	},
	inviteSuccessFlagMultiInviteSent: {
		id: 'townsquare.invite-user-modal.invite-success-flag.multi-invite-sent',
		defaultMessage:
			"You've added {invitedCount, plural, one {# person} other {# people}} to your space. You'll see them on the board once they've been assigned work items.",
		description: 'The content of a notification shown to users indicating invites have been sent to multiple users',
	},
	inviteSuccessFlagViewUsers: {
		id: 'townsquare.invite-user-modal.invite-success-flag.view-users',
		defaultMessage: 'View users',
		description:
			'The link label on a notification shown to admins so that they may click to see users in project settings',
	},
	requestAccessSuccessFlagTitle: {
		id: 'townsquare.invite-user-modal.request-access-success-flag.title',
		defaultMessage: "You've requested access for {count, plural, one {# user} other {# users}}",
		description:
			'The title of a notification shown to users indicating one or many requests for access have been sent and are awaiting approval',
	},
	requestAccessSuccessFlagDescription: {
		id: 'townsquare.invite-user-modal.request-access-success-flag.description',
		defaultMessage: 'They will be able to start collaborating when your admin approves their access request.',
		description:
			'The content of a notification shown to users indicating one or many requests for access have been sent and are awaiting approval',
	},
	inviteFailedFlagTitle: {
		id: 'townsquare.invite-user-modal.invite-failed-flag.title',
		defaultMessage: '{failedCount, plural, one {# Invite} other {# Invites}} not sent',
		description: 'The title of a notification shown to users indicating an invite failed due to tech issues',
	},
	inviteFailedFlagOneInviteFailed: {
		id: 'townsquare.invite-user-modal.invite-failed-flag.one-invite-failed',
		defaultMessage: "We couldn't invite {email}.",
		description: 'The content of a notification shown to users indicating the invitation failed to send',
	},
	inviteFailedFlagManyInvitesFailed: {
		id: 'townsquare.invite-user-modal.invite-failed-flag.many-invites-failed',
		defaultMessage: "We couldn't send any invitations.",
		description: 'The content of a notification shown to users indicating no invitations were sent',
	},
	inviteFailedFlagContactSupport: {
		id: 'townsquare.invite-user-modal.invite-failed-flag.contact-support',
		defaultMessage: 'Contact support',
		description:
			'The link label on a notification shown to users so that they may click to be shown a page and contact support',
	},
	inviteFailedUserLimitFlagTitle: {
		id: 'townsquare.invite-user-modal.invite-failed-user-limit-flag.title',
		defaultMessage: '{failedCount, plural, one {# invite} other {# invites}} not sent',
		description:
			'The title of a notification shown to trusted users indicating some invites failed due to user limit reached',
	},
	inviteFailedUserLimitFlagOneInviteFailedAdmin: {
		id: 'townsquare.invite-user-modal.invite-failed-user-limit-flag.one-invite-failed-admin',
		defaultMessage: "We couldn't invite {email} because you've reached your user limit.",
		description: 'The content of a notification shown to admins indicating one failed invite due to user limit reached',
	},
	inviteFailedUserLimitFlagManyInvitesFailedAdmin: {
		id: 'townsquare.invite-user-modal.invite-failed-user-limit-flag.many-invites-failed-admin',
		defaultMessage:
			"We couldn't send {failedCount, plural, one {# of your invite} other {# of your invites}} because you've reached your user limit.",
		description:
			'The content of a notification shown to admins indicating multiple failed invites due to user limit reached',
	},
	inviteFailedUserLimitFlagInviteFailedTrustedUsers: {
		id: 'townsquare.invite-user-modal.invite-failed-user-limit-flag.invite-failed-trusted-users',
		defaultMessage:
			"We couldn't invite {failedCount, plural, one {# person} other {# people}} because you've reached your user limit. Contact your admin for help.",
		description:
			'The content of a notification shown to trusted users indicating some invites failed due to user limit reached',
	},
	inviteFailedUserLimitFlagUpgradePlan: {
		id: 'townsquare.invite-user-modal.invite-failed-user-limit-flag.upgrade-plan',
		defaultMessage: 'Upgrade plan',
		description:
			'The link label on a notification shown to users so that they may click to load a new page to upgrade their products plan',
	},
	inviteFailedUserLimitFlagContactSupport: {
		id: 'townsquare.invite-user-modal.invite-failed-user-limit-flag.contact-support',
		defaultMessage: 'Contact support',
		description:
			'The link label on a notification shown to users so that they may click to be shown a page and contact support',
	},
});
